import { Component } from '@angular/core';
import { SharedModule } from '../../../../../../shared/shared.module';

@Component({
  selector: 'app-activity-drawer',
  templateUrl: './activity-drawer.component.html',
  imports: [SharedModule],
})
export class ActivityDrawerComponent {}
